export default () => {
    const images = document.querySelectorAll('.woocommerce-product-gallery img');

    if (!images) {
        return;
    }

    for (const el of images) {
        el.addEventListener('click', (e) => e.preventDefault());
    }
};
